import React from 'react';
import { ReactComponent as DocumentIcon } from '../../../shared/icons/document-icon.svg';
import { ReactComponent as FolderIcon } from '../../../shared/icons/folder-icon.svg';
import { ReactComponent as ChevronRightIcon } from '../../../shared/icons/chevron-right.svg';
import styles from './ChatScopeSelector.module.scss';

export type ChatScope = 'document' | 'deal';

interface ChatScopeSelectorProps {
  onScopeSelect: (scope: ChatScope) => void;
}

export const ChatScopeSelector: React.FC<ChatScopeSelectorProps> = ({ onScopeSelect }) => {
  return (
    <div className={styles.scopeSelector}>
      <div className={styles.welcomeHeader}>
        <h2>What would you like to chat about?</h2>
      </div>

      <div className={styles.scopeButtons}>
        <button
          className={styles.scopeButton}
          onClick={() => onScopeSelect('document')}
          aria-label="Chat about a specific document"
        >
          <DocumentIcon className={styles.icon} />
          <div className={styles.buttonContent}>
            <span className={styles.buttonLabel}>A Document</span>
            <span className={styles.buttonDescription}>Chat about a specific document</span>
          </div>
          <ChevronRightIcon className={styles.chevron} />
        </button>

        <button
          className={styles.scopeButton}
          onClick={() => onScopeSelect('deal')}
          aria-label="Chat about all documents in a deal"
        >
          <FolderIcon className={styles.icon} />
          <div className={styles.buttonContent}>
            <span className={styles.buttonLabel}>A Deal</span>
            <span className={styles.buttonDescription}>Chat about all documents in a deal (includes PDFs)</span>
          </div>
          <ChevronRightIcon className={styles.chevron} />
        </button>
      </div>
    </div>
  );
};